/**
 * @generated SignedSource<<dc7cc9800e438da89bb10b9bb2d1bc59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssignmentDueAtStatus = "DUE_SOON" | "NONE" | "OVERDUE" | "%future added value";
export type AssignmentStatus = "ACCEPTED" | "CANCELED" | "IN_PROGRESS" | "NONE" | "NOT_STARTED" | "READY_FOR_REVIEW" | "REJECTED" | "UNDER_REVIEW" | "%future added value";
export type FeedbackLevel = "CRITICAL" | "MAJOR" | "MINOR" | "SUGGESTION" | "%future added value";
export type FlowType = "BLUEPRINT" | "NONE" | "%future added value";
export type FlowsOrderBy = "ACTIVITIES_BY_FLOW_ID__COUNT_ASC" | "ACTIVITIES_BY_FLOW_ID__COUNT_DESC" | "ADMIN_DASHBOARD_FLOW_COMMENTS_BY_FLOW_ID__COUNT_ASC" | "ADMIN_DASHBOARD_FLOW_COMMENTS_BY_FLOW_ID__COUNT_DESC" | "ARCHIVED_AT_ASC" | "ARCHIVED_AT_DESC" | "ASSIGNED_AT_ASC" | "ASSIGNED_AT_DESC" | "ASSIGNED_BY_ID_ASC" | "ASSIGNED_BY_ID_DESC" | "ASSIGNED_TO_ID_ASC" | "ASSIGNED_TO_ID_DESC" | "ASSIGNMENT_DUE_AT_STATUS_ASC" | "ASSIGNMENT_DUE_AT_STATUS_DESC" | "ASSIGNMENT_STATUS_ASC" | "ASSIGNMENT_STATUS_DESC" | "COMPLETED_AT_ASC" | "COMPLETED_AT_DESC" | "CREATED_AT_ASC" | "CREATED_AT_DESC" | "DESCRIPTION_ASC" | "DESCRIPTION_DESC" | "DUE_AT_ASC" | "DUE_AT_DESC" | "DURATION_SECONDS_ASC" | "DURATION_SECONDS_DESC" | "FLOW_COMMENTS_BY_FLOW_ID__COUNT_ASC" | "FLOW_COMMENTS_BY_FLOW_ID__COUNT_DESC" | "FLOW_FAVORITES_BY_FLOW_ID__COUNT_ASC" | "FLOW_FAVORITES_BY_FLOW_ID__COUNT_DESC" | "FLOW_REVIEWERS_BY_FLOW_ID__COUNT_ASC" | "FLOW_REVIEWERS_BY_FLOW_ID__COUNT_DESC" | "FLOW_TYPE_ASC" | "FLOW_TYPE_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__ARCHIVED_AT_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__ARCHIVED_AT_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__COMPANY_ID_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__COMPANY_ID_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__CREATED_AT_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__CREATED_AT_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_BULK_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_BULK_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_BULK_TIME_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_BULK_TIME_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_MODULE_NOTIFICATIONS_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_MODULE_NOTIFICATIONS_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_ON_ALL_ASSIGNMENT_STATUS_CHANGES_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_ON_ALL_ASSIGNMENT_STATUS_CHANGES_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_ON_COMMENT_ADDED_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_ON_COMMENT_ADDED_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_ON_FEEDBACK_PROVIDED_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__EMAIL_ON_FEEDBACK_PROVIDED_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__FIRST_NAME_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__FIRST_NAME_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__FULL_NAME_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__FULL_NAME_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__ID_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__ID_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__IS_SYSTEM_USER_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__IS_SYSTEM_USER_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__JOB_TITLE_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__JOB_TITLE_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__LAN_ID_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__LAN_ID_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__LAST_NAME_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__LAST_NAME_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__PARTNERSONLINE_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__PARTNERSONLINE_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__PROGRAMS_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__PROGRAMS_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__PRONOUNS_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__PRONOUNS_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__STATUS_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__STATUS_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__UPDATED_AT_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__UPDATED_AT_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__USER_PRIORITY_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__USER_PRIORITY_DESC" | "GWT_USER_BY_ASSIGNED_BY_ID__USER_TYPE_ASC" | "GWT_USER_BY_ASSIGNED_BY_ID__USER_TYPE_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__ARCHIVED_AT_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__ARCHIVED_AT_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__COMPANY_ID_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__COMPANY_ID_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__CREATED_AT_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__CREATED_AT_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_BULK_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_BULK_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_BULK_TIME_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_BULK_TIME_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_MODULE_NOTIFICATIONS_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_MODULE_NOTIFICATIONS_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_ON_ALL_ASSIGNMENT_STATUS_CHANGES_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_ON_ALL_ASSIGNMENT_STATUS_CHANGES_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_ON_COMMENT_ADDED_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_ON_COMMENT_ADDED_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_ON_FEEDBACK_PROVIDED_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__EMAIL_ON_FEEDBACK_PROVIDED_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__FIRST_NAME_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__FIRST_NAME_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__FULL_NAME_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__FULL_NAME_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__ID_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__ID_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__IS_SYSTEM_USER_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__IS_SYSTEM_USER_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__JOB_TITLE_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__JOB_TITLE_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__LAN_ID_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__LAN_ID_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__LAST_NAME_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__LAST_NAME_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__PARTNERSONLINE_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__PARTNERSONLINE_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__PROGRAMS_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__PROGRAMS_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__PRONOUNS_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__PRONOUNS_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__STATUS_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__STATUS_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__UPDATED_AT_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__UPDATED_AT_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__USER_PRIORITY_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__USER_PRIORITY_DESC" | "GWT_USER_BY_ASSIGNED_TO_ID__USER_TYPE_ASC" | "GWT_USER_BY_ASSIGNED_TO_ID__USER_TYPE_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__ARCHIVED_AT_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__ARCHIVED_AT_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__COMPANY_ID_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__COMPANY_ID_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__CREATED_AT_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__CREATED_AT_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_BULK_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_BULK_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_BULK_TIME_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_BULK_TIME_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_MODULE_NOTIFICATIONS_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_MODULE_NOTIFICATIONS_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_ON_ALL_ASSIGNMENT_STATUS_CHANGES_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_ON_ALL_ASSIGNMENT_STATUS_CHANGES_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_ON_COMMENT_ADDED_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_ON_COMMENT_ADDED_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_ON_FEEDBACK_PROVIDED_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__EMAIL_ON_FEEDBACK_PROVIDED_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__FIRST_NAME_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__FIRST_NAME_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__FULL_NAME_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__FULL_NAME_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__ID_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__ID_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__IS_SYSTEM_USER_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__IS_SYSTEM_USER_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__JOB_TITLE_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__JOB_TITLE_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__LAN_ID_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__LAN_ID_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__LAST_NAME_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__LAST_NAME_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__PARTNERSONLINE_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__PARTNERSONLINE_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__PROGRAMS_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__PROGRAMS_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__PRONOUNS_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__PRONOUNS_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__STATUS_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__STATUS_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__UPDATED_AT_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__UPDATED_AT_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__USER_PRIORITY_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__USER_PRIORITY_DESC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__USER_TYPE_ASC" | "GWT_USER_BY_LAST_MODIFIED_BY_ID__USER_TYPE_DESC" | "GWT_USER_BY_OWNER_ID__ARCHIVED_AT_ASC" | "GWT_USER_BY_OWNER_ID__ARCHIVED_AT_DESC" | "GWT_USER_BY_OWNER_ID__COMPANY_ID_ASC" | "GWT_USER_BY_OWNER_ID__COMPANY_ID_DESC" | "GWT_USER_BY_OWNER_ID__CREATED_AT_ASC" | "GWT_USER_BY_OWNER_ID__CREATED_AT_DESC" | "GWT_USER_BY_OWNER_ID__EMAIL_ASC" | "GWT_USER_BY_OWNER_ID__EMAIL_BULK_ASC" | "GWT_USER_BY_OWNER_ID__EMAIL_BULK_DESC" | "GWT_USER_BY_OWNER_ID__EMAIL_BULK_TIME_ASC" | "GWT_USER_BY_OWNER_ID__EMAIL_BULK_TIME_DESC" | "GWT_USER_BY_OWNER_ID__EMAIL_DESC" | "GWT_USER_BY_OWNER_ID__EMAIL_MODULE_NOTIFICATIONS_ASC" | "GWT_USER_BY_OWNER_ID__EMAIL_MODULE_NOTIFICATIONS_DESC" | "GWT_USER_BY_OWNER_ID__EMAIL_ON_ALL_ASSIGNMENT_STATUS_CHANGES_ASC" | "GWT_USER_BY_OWNER_ID__EMAIL_ON_ALL_ASSIGNMENT_STATUS_CHANGES_DESC" | "GWT_USER_BY_OWNER_ID__EMAIL_ON_COMMENT_ADDED_ASC" | "GWT_USER_BY_OWNER_ID__EMAIL_ON_COMMENT_ADDED_DESC" | "GWT_USER_BY_OWNER_ID__EMAIL_ON_FEEDBACK_PROVIDED_ASC" | "GWT_USER_BY_OWNER_ID__EMAIL_ON_FEEDBACK_PROVIDED_DESC" | "GWT_USER_BY_OWNER_ID__FIRST_NAME_ASC" | "GWT_USER_BY_OWNER_ID__FIRST_NAME_DESC" | "GWT_USER_BY_OWNER_ID__FULL_NAME_ASC" | "GWT_USER_BY_OWNER_ID__FULL_NAME_DESC" | "GWT_USER_BY_OWNER_ID__ID_ASC" | "GWT_USER_BY_OWNER_ID__ID_DESC" | "GWT_USER_BY_OWNER_ID__IS_SYSTEM_USER_ASC" | "GWT_USER_BY_OWNER_ID__IS_SYSTEM_USER_DESC" | "GWT_USER_BY_OWNER_ID__JOB_TITLE_ASC" | "GWT_USER_BY_OWNER_ID__JOB_TITLE_DESC" | "GWT_USER_BY_OWNER_ID__LAN_ID_ASC" | "GWT_USER_BY_OWNER_ID__LAN_ID_DESC" | "GWT_USER_BY_OWNER_ID__LAST_NAME_ASC" | "GWT_USER_BY_OWNER_ID__LAST_NAME_DESC" | "GWT_USER_BY_OWNER_ID__PARTNERSONLINE_ASC" | "GWT_USER_BY_OWNER_ID__PARTNERSONLINE_DESC" | "GWT_USER_BY_OWNER_ID__PROGRAMS_ASC" | "GWT_USER_BY_OWNER_ID__PROGRAMS_DESC" | "GWT_USER_BY_OWNER_ID__PRONOUNS_ASC" | "GWT_USER_BY_OWNER_ID__PRONOUNS_DESC" | "GWT_USER_BY_OWNER_ID__STATUS_ASC" | "GWT_USER_BY_OWNER_ID__STATUS_DESC" | "GWT_USER_BY_OWNER_ID__UPDATED_AT_ASC" | "GWT_USER_BY_OWNER_ID__UPDATED_AT_DESC" | "GWT_USER_BY_OWNER_ID__USER_PRIORITY_ASC" | "GWT_USER_BY_OWNER_ID__USER_PRIORITY_DESC" | "GWT_USER_BY_OWNER_ID__USER_TYPE_ASC" | "GWT_USER_BY_OWNER_ID__USER_TYPE_DESC" | "ID_ASC" | "ID_DESC" | "LAST_MODIFIED_BY_ID_ASC" | "LAST_MODIFIED_BY_ID_DESC" | "LINKED_TYPE_ASC" | "LINKED_TYPE_DESC" | "MODULE_BY_FLOW_ID__ARCHIVED_AT_ASC" | "MODULE_BY_FLOW_ID__ARCHIVED_AT_DESC" | "MODULE_BY_FLOW_ID__ATTEMPTS_ASC" | "MODULE_BY_FLOW_ID__ATTEMPTS_DESC" | "MODULE_BY_FLOW_ID__AUTO_START_NEXT_MODULE_FLOW_ID_ASC" | "MODULE_BY_FLOW_ID__AUTO_START_NEXT_MODULE_FLOW_ID_DESC" | "MODULE_BY_FLOW_ID__CURRENT_ATTEMPT_ASC" | "MODULE_BY_FLOW_ID__CURRENT_ATTEMPT_DESC" | "MODULE_BY_FLOW_ID__FLOW_ID_ASC" | "MODULE_BY_FLOW_ID__FLOW_ID_DESC" | "MODULE_BY_FLOW_ID__GALLERY_ASSET_COMPONENTS_ID_ASC" | "MODULE_BY_FLOW_ID__GALLERY_ASSET_COMPONENTS_ID_DESC" | "MODULE_BY_FLOW_ID__GALLERY_ASSET_DELIVERABLE_ID_ASC" | "MODULE_BY_FLOW_ID__GALLERY_ASSET_DELIVERABLE_ID_DESC" | "MODULE_BY_FLOW_ID__GALLERY_COLLECTION_SUBMISSIONS_ID_ASC" | "MODULE_BY_FLOW_ID__GALLERY_COLLECTION_SUBMISSIONS_ID_DESC" | "MODULE_BY_FLOW_ID__GROUP_MODULE_PREVIOUS_MODULE_FLOW_ID_ASC" | "MODULE_BY_FLOW_ID__GROUP_MODULE_PREVIOUS_MODULE_FLOW_ID_DESC" | "MODULE_BY_FLOW_ID__MODULE_GROUP_ID_ASC" | "MODULE_BY_FLOW_ID__MODULE_GROUP_ID_DESC" | "MODULE_BY_FLOW_ID__PROGRAM_TYPE_ASC" | "MODULE_BY_FLOW_ID__PROGRAM_TYPE_DESC" | "MODULE_BY_FLOW_ID__SOFTWARE_TYPE_ASC" | "MODULE_BY_FLOW_ID__SOFTWARE_TYPE_DESC" | "MODULE_BY_FLOW_ID__SUBMISSION_LOCK_ASC" | "MODULE_BY_FLOW_ID__SUBMISSION_LOCK_DESC" | "MODULE_BY_FLOW_ID__TEMPLATE_FLOW_ID_ASC" | "MODULE_BY_FLOW_ID__TEMPLATE_FLOW_ID_DESC" | "MODULE_BY_FLOW_ID__VERSION_NUMBER_ASC" | "MODULE_BY_FLOW_ID__VERSION_NUMBER_DESC" | "MODULE_GROUP_BY_FLOW_ID__ARCHIVED_AT_ASC" | "MODULE_GROUP_BY_FLOW_ID__ARCHIVED_AT_DESC" | "MODULE_GROUP_BY_FLOW_ID__FLOW_ID_ASC" | "MODULE_GROUP_BY_FLOW_ID__FLOW_ID_DESC" | "MODULE_GROUP_BY_FLOW_ID__SHUFFLE_ASC" | "MODULE_GROUP_BY_FLOW_ID__SHUFFLE_DESC" | "MODULE_GROUP_BY_FLOW_ID__VERSION_NUMBER_ASC" | "MODULE_GROUP_BY_FLOW_ID__VERSION_NUMBER_DESC" | "NAME_ASC" | "NAME_DESC" | "NATURAL" | "OWNER_ID_ASC" | "OWNER_ID_DESC" | "PRIMARY_KEY_ASC" | "PRIMARY_KEY_DESC" | "REVIEWER_DASHBOARD_FLOW_COMMENTS_BY_FLOW_ID__COUNT_ASC" | "REVIEWER_DASHBOARD_FLOW_COMMENTS_BY_FLOW_ID__COUNT_DESC" | "STARTED_AT_ASC" | "STARTED_AT_DESC" | "STATUS_CHANGED_AT_ASC" | "STATUS_CHANGED_AT_DESC" | "TASK_BY_FLOW_ID__ARCHIVED_AT_ASC" | "TASK_BY_FLOW_ID__ARCHIVED_AT_DESC" | "TASK_BY_FLOW_ID__COMPLETE_ASC" | "TASK_BY_FLOW_ID__COMPLETE_DESC" | "TASK_BY_FLOW_ID__FLOW_ID_ASC" | "TASK_BY_FLOW_ID__FLOW_ID_DESC" | "TASK_BY_FLOW_ID__MODULE_FLOW_ID_ASC" | "TASK_BY_FLOW_ID__MODULE_FLOW_ID_DESC" | "TASK_BY_FLOW_ID__PRIORITY_ASC" | "TASK_BY_FLOW_ID__PRIORITY_DESC" | "TASK_BY_FLOW_ID__TEMPLATE_FLOW_ID_ASC" | "TASK_BY_FLOW_ID__TEMPLATE_FLOW_ID_DESC" | "TEMPLATE_BY_FLOW_ID__ARCHIVED_AT_ASC" | "TEMPLATE_BY_FLOW_ID__ARCHIVED_AT_DESC" | "TEMPLATE_BY_FLOW_ID__FLOW_ID_ASC" | "TEMPLATE_BY_FLOW_ID__FLOW_ID_DESC" | "UPDATED_AT_ASC" | "UPDATED_AT_DESC" | "WORKFLOW_TYPE_ASC" | "WORKFLOW_TYPE_DESC" | "%future added value";
export type LinkedType = "MODULE" | "MODULE_GROUP" | "TASK" | "TEMPLATE" | "UNKNOWN" | "%future added value";
export type PolFileUploadStatus = "ERROR" | "NOT_STARTED" | "SCANNING" | "SUCCESS" | "WAITING_FOR_JOB" | "%future added value";
export type ProgramType = "ACCESSORIES_3_D_ACCREDITATION" | "A_A_3_D_ACCREDITATION" | "NONE" | "SOFT_HOME_3_D_ACCREDITATION" | "_3_D_STYLING" | "%future added value";
export type SoftwareType = "BROWZWEAR" | "CLO" | "NONE" | "OPTITEX" | "%future added value";
export type SubmissionStatus = "ACCEPTED" | "READY_FOR_REVIEW" | "REJECTED" | "%future added value";
export type UserStatus = "ACTIVE" | "DEACTIVATED" | "SUSPENDED" | "%future added value";
export type UserType = "ADMIN" | "BLOCKED" | "EXTERNAL_USER" | "INTERNAL_USER" | "REVIEWER" | "%future added value";
export type WorkflowType = "ACCREDITATION" | "%future added value";
export type FlowFilter = {
  activities?: FlowToManyActivityFilter | null | undefined;
  activitiesExist?: boolean | null | undefined;
  adminDashboardFlowComments?: FlowToManyAdminDashboardFlowCommentFilter | null | undefined;
  adminDashboardFlowCommentsExist?: boolean | null | undefined;
  and?: ReadonlyArray<FlowFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  assignedAt?: DatetimeFilter | null | undefined;
  assignedBy?: GwtUserFilter | null | undefined;
  assignedByExists?: boolean | null | undefined;
  assignedById?: UUIDFilter | null | undefined;
  assignedTo?: GwtUserFilter | null | undefined;
  assignedToExists?: boolean | null | undefined;
  assignedToId?: UUIDFilter | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatusFilter | null | undefined;
  assignmentStatus?: AssignmentStatusFilter | null | undefined;
  completedAt?: DatetimeFilter | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  description?: StringFilter | null | undefined;
  dueAt?: DatetimeFilter | null | undefined;
  durationInSeconds?: IntFilter | null | undefined;
  durationSeconds?: IntFilter | null | undefined;
  flowComments?: FlowToManyFlowCommentFilter | null | undefined;
  flowCommentsExist?: boolean | null | undefined;
  flowFavorites?: FlowToManyFlowFavoriteFilter | null | undefined;
  flowFavoritesExist?: boolean | null | undefined;
  flowReviewers?: FlowToManyFlowReviewerFilter | null | undefined;
  flowReviewersExist?: boolean | null | undefined;
  flowType?: FlowTypeFilter | null | undefined;
  lastModifiedBy?: GwtUserFilter | null | undefined;
  lastModifiedByExists?: boolean | null | undefined;
  lastModifiedById?: UUIDFilter | null | undefined;
  linkedType?: LinkedTypeFilter | null | undefined;
  module?: ModuleFilter | null | undefined;
  moduleExists?: boolean | null | undefined;
  moduleGroup?: ModuleGroupFilter | null | undefined;
  moduleGroupExists?: boolean | null | undefined;
  name?: StringFilter | null | undefined;
  not?: FlowFilter | null | undefined;
  or?: ReadonlyArray<FlowFilter> | null | undefined;
  owner?: GwtUserFilter | null | undefined;
  ownerId?: UUIDFilter | null | undefined;
  reviewerDashboardFlowComments?: FlowToManyReviewerDashboardFlowCommentFilter | null | undefined;
  reviewerDashboardFlowCommentsExist?: boolean | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  startedAt?: DatetimeFilter | null | undefined;
  statusChangedAt?: DatetimeFilter | null | undefined;
  task?: TaskFilter | null | undefined;
  taskExists?: boolean | null | undefined;
  template?: TemplateFilter | null | undefined;
  templateExists?: boolean | null | undefined;
  updatedAt?: DatetimeFilter | null | undefined;
  workflowType?: WorkflowTypeFilter | null | undefined;
};
export type UUIDFilter = {
  equalTo?: UUID | null | undefined;
  greaterThan?: UUID | null | undefined;
  greaterThanOrEqualTo?: UUID | null | undefined;
  in?: ReadonlyArray<UUID> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: UUID | null | undefined;
  lessThanOrEqualTo?: UUID | null | undefined;
  notEqualTo?: UUID | null | undefined;
  notIn?: ReadonlyArray<UUID> | null | undefined;
};
export type AssignmentStatusFilter = {
  equalTo?: AssignmentStatus | null | undefined;
  greaterThan?: AssignmentStatus | null | undefined;
  greaterThanOrEqualTo?: AssignmentStatus | null | undefined;
  in?: ReadonlyArray<AssignmentStatus> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: AssignmentStatus | null | undefined;
  lessThanOrEqualTo?: AssignmentStatus | null | undefined;
  notEqualTo?: AssignmentStatus | null | undefined;
  notIn?: ReadonlyArray<AssignmentStatus> | null | undefined;
};
export type DatetimeFilter = {
  equalTo?: Date | null | undefined;
  greaterThan?: Date | null | undefined;
  greaterThanOrEqualTo?: Date | null | undefined;
  in?: ReadonlyArray<Date> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: Date | null | undefined;
  lessThanOrEqualTo?: Date | null | undefined;
  notEqualTo?: Date | null | undefined;
  notIn?: ReadonlyArray<Date> | null | undefined;
};
export type FlowTypeFilter = {
  equalTo?: FlowType | null | undefined;
  greaterThan?: FlowType | null | undefined;
  greaterThanOrEqualTo?: FlowType | null | undefined;
  in?: ReadonlyArray<FlowType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: FlowType | null | undefined;
  lessThanOrEqualTo?: FlowType | null | undefined;
  notEqualTo?: FlowType | null | undefined;
  notIn?: ReadonlyArray<FlowType> | null | undefined;
};
export type LinkedTypeFilter = {
  equalTo?: LinkedType | null | undefined;
  greaterThan?: LinkedType | null | undefined;
  greaterThanOrEqualTo?: LinkedType | null | undefined;
  in?: ReadonlyArray<LinkedType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: LinkedType | null | undefined;
  lessThanOrEqualTo?: LinkedType | null | undefined;
  notEqualTo?: LinkedType | null | undefined;
  notIn?: ReadonlyArray<LinkedType> | null | undefined;
};
export type WorkflowTypeFilter = {
  equalTo?: WorkflowType | null | undefined;
  greaterThan?: WorkflowType | null | undefined;
  greaterThanOrEqualTo?: WorkflowType | null | undefined;
  in?: ReadonlyArray<WorkflowType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: WorkflowType | null | undefined;
  lessThanOrEqualTo?: WorkflowType | null | undefined;
  notEqualTo?: WorkflowType | null | undefined;
  notIn?: ReadonlyArray<WorkflowType> | null | undefined;
};
export type StringFilter = {
  equalTo?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqualTo?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqualTo?: string | null | undefined;
  likeInsensitive?: string | null | undefined;
  notEqualTo?: string | null | undefined;
  notIn?: ReadonlyArray<string> | null | undefined;
};
export type AssignmentDueAtStatusFilter = {
  equalTo?: AssignmentDueAtStatus | null | undefined;
  greaterThan?: AssignmentDueAtStatus | null | undefined;
  greaterThanOrEqualTo?: AssignmentDueAtStatus | null | undefined;
  in?: ReadonlyArray<AssignmentDueAtStatus> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: AssignmentDueAtStatus | null | undefined;
  lessThanOrEqualTo?: AssignmentDueAtStatus | null | undefined;
  notEqualTo?: AssignmentDueAtStatus | null | undefined;
  notIn?: ReadonlyArray<AssignmentDueAtStatus> | null | undefined;
};
export type IntFilter = {
  equalTo?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqualTo?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqualTo?: number | null | undefined;
  notEqualTo?: number | null | undefined;
  notIn?: ReadonlyArray<number> | null | undefined;
};
export type FlowToManyActivityFilter = {
  every?: ActivityFilter | null | undefined;
  none?: ActivityFilter | null | undefined;
  some?: ActivityFilter | null | undefined;
};
export type ActivityFilter = {
  and?: ReadonlyArray<ActivityFilter> | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowExists?: boolean | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  linkLocation?: StringFilter | null | undefined;
  not?: ActivityFilter | null | undefined;
  object?: StringFilter | null | undefined;
  or?: ReadonlyArray<ActivityFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  verb?: StringFilter | null | undefined;
  workflowType?: WorkflowTypeFilter | null | undefined;
};
export type GwtUserFilter = {
  activities?: GwtUserToManyActivityFilter | null | undefined;
  activitiesExist?: boolean | null | undefined;
  allCertifications?: StringListFilter | null | undefined;
  and?: ReadonlyArray<GwtUserFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  commentVieweds?: GwtUserToManyCommentViewedFilter | null | undefined;
  commentViewedsExist?: boolean | null | undefined;
  comments?: GwtUserToManyCommentFilter | null | undefined;
  commentsExist?: boolean | null | undefined;
  companiesByOwnerId?: GwtUserToManyCompanyFilter | null | undefined;
  companiesByOwnerIdExist?: boolean | null | undefined;
  company?: CompanyFilter | null | undefined;
  companyExists?: boolean | null | undefined;
  companyId?: UUIDFilter | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  email?: StringFilter | null | undefined;
  emailBulk?: BooleanFilter | null | undefined;
  emailBulkTime?: DatetimeFilter | null | undefined;
  emailModuleNotifications?: StringListFilter | null | undefined;
  emailOnAllAssignmentStatusChanges?: BooleanFilter | null | undefined;
  emailOnCommentAdded?: BooleanFilter | null | undefined;
  emailOnFeedbackProvided?: BooleanFilter | null | undefined;
  feedbacks?: GwtUserToManyFeedbackFilter | null | undefined;
  feedbacksByClaimedById?: GwtUserToManyFeedbackFilter | null | undefined;
  feedbacksByClaimedByIdExist?: boolean | null | undefined;
  feedbacksExist?: boolean | null | undefined;
  firstName?: StringFilter | null | undefined;
  flowFavorites?: GwtUserToManyFlowFavoriteFilter | null | undefined;
  flowFavoritesExist?: boolean | null | undefined;
  flowsByAssignedById?: GwtUserToManyFlowFilter | null | undefined;
  flowsByAssignedByIdExist?: boolean | null | undefined;
  flowsByAssignedToId?: GwtUserToManyFlowFilter | null | undefined;
  flowsByAssignedToIdExist?: boolean | null | undefined;
  flowsByLastModifiedById?: GwtUserToManyFlowFilter | null | undefined;
  flowsByLastModifiedByIdExist?: boolean | null | undefined;
  flowsByOwnerId?: GwtUserToManyFlowFilter | null | undefined;
  flowsByOwnerIdExist?: boolean | null | undefined;
  fullName?: StringFilter | null | undefined;
  isSystemUser?: BooleanFilter | null | undefined;
  jobTitle?: StringFilter | null | undefined;
  lanId?: StringFilter | null | undefined;
  lastName?: StringFilter | null | undefined;
  moduleSubmissionsByAcceptedById?: GwtUserToManyModuleSubmissionFilter | null | undefined;
  moduleSubmissionsByAcceptedByIdExist?: boolean | null | undefined;
  not?: GwtUserFilter | null | undefined;
  notifications?: GwtUserToManyNotificationFilter | null | undefined;
  notificationsExist?: boolean | null | undefined;
  or?: ReadonlyArray<GwtUserFilter> | null | undefined;
  partnersonline?: BooleanFilter | null | undefined;
  polFileUploads?: GwtUserToManyPolFileUploadFilter | null | undefined;
  polFileUploadsExist?: boolean | null | undefined;
  programs?: ProgramTypeListFilter | null | undefined;
  pronouns?: StringFilter | null | undefined;
  reviewedFlowReviewers?: GwtUserToManyFlowReviewerFilter | null | undefined;
  reviewedFlowReviewersExist?: boolean | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  status?: UserStatusFilter | null | undefined;
  updatedAt?: DatetimeFilter | null | undefined;
  userPriority?: IntFilter | null | undefined;
  userType?: UserTypeFilter | null | undefined;
};
export type UserTypeFilter = {
  equalTo?: UserType | null | undefined;
  greaterThan?: UserType | null | undefined;
  greaterThanOrEqualTo?: UserType | null | undefined;
  in?: ReadonlyArray<UserType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: UserType | null | undefined;
  lessThanOrEqualTo?: UserType | null | undefined;
  notEqualTo?: UserType | null | undefined;
  notIn?: ReadonlyArray<UserType> | null | undefined;
};
export type BooleanFilter = {
  equalTo?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqualTo?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqualTo?: boolean | null | undefined;
  notEqualTo?: boolean | null | undefined;
  notIn?: ReadonlyArray<boolean> | null | undefined;
};
export type StringListFilter = {
  equalTo?: ReadonlyArray<string | null | undefined> | null | undefined;
  greaterThan?: ReadonlyArray<string | null | undefined> | null | undefined;
  greaterThanOrEqualTo?: ReadonlyArray<string | null | undefined> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: ReadonlyArray<string | null | undefined> | null | undefined;
  lessThanOrEqualTo?: ReadonlyArray<string | null | undefined> | null | undefined;
  notEqualTo?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type UserStatusFilter = {
  equalTo?: UserStatus | null | undefined;
  greaterThan?: UserStatus | null | undefined;
  greaterThanOrEqualTo?: UserStatus | null | undefined;
  in?: ReadonlyArray<UserStatus> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: UserStatus | null | undefined;
  lessThanOrEqualTo?: UserStatus | null | undefined;
  notEqualTo?: UserStatus | null | undefined;
  notIn?: ReadonlyArray<UserStatus> | null | undefined;
};
export type ProgramTypeListFilter = {
  equalTo?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  greaterThan?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  greaterThanOrEqualTo?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  lessThanOrEqualTo?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  notEqualTo?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
};
export type GwtUserToManyCommentFilter = {
  every?: CommentFilter | null | undefined;
  none?: CommentFilter | null | undefined;
  some?: CommentFilter | null | undefined;
};
export type CommentFilter = {
  adminDashboardFlowComments?: CommentToManyAdminDashboardFlowCommentFilter | null | undefined;
  adminDashboardFlowCommentsExist?: boolean | null | undefined;
  and?: ReadonlyArray<CommentFilter> | null | undefined;
  commentByResponseTo?: CommentFilter | null | undefined;
  commentByResponseToExists?: boolean | null | undefined;
  commentText?: StringFilter | null | undefined;
  commentVieweds?: CommentToManyCommentViewedFilter | null | undefined;
  commentViewedsExist?: boolean | null | undefined;
  commentsByResponseTo?: CommentToManyCommentFilter | null | undefined;
  commentsByResponseToExist?: boolean | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  flowComments?: CommentToManyFlowCommentFilter | null | undefined;
  flowCommentsExist?: boolean | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  not?: CommentFilter | null | undefined;
  or?: ReadonlyArray<CommentFilter> | null | undefined;
  responseTo?: UUIDFilter | null | undefined;
  reviewerDashboardFlowComments?: CommentToManyReviewerDashboardFlowCommentFilter | null | undefined;
  reviewerDashboardFlowCommentsExist?: boolean | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  updatedAt?: DatetimeFilter | null | undefined;
};
export type CommentToManyCommentFilter = {
  every?: CommentFilter | null | undefined;
  none?: CommentFilter | null | undefined;
  some?: CommentFilter | null | undefined;
};
export type CommentToManyFlowCommentFilter = {
  every?: FlowCommentFilter | null | undefined;
  none?: FlowCommentFilter | null | undefined;
  some?: FlowCommentFilter | null | undefined;
};
export type FlowCommentFilter = {
  and?: ReadonlyArray<FlowCommentFilter> | null | undefined;
  comment?: CommentFilter | null | undefined;
  commentId?: UUIDFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  not?: FlowCommentFilter | null | undefined;
  or?: ReadonlyArray<FlowCommentFilter> | null | undefined;
};
export type CommentToManyAdminDashboardFlowCommentFilter = {
  every?: AdminDashboardFlowCommentFilter | null | undefined;
  none?: AdminDashboardFlowCommentFilter | null | undefined;
  some?: AdminDashboardFlowCommentFilter | null | undefined;
};
export type AdminDashboardFlowCommentFilter = {
  and?: ReadonlyArray<AdminDashboardFlowCommentFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  comment?: CommentFilter | null | undefined;
  commentId?: UUIDFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  not?: AdminDashboardFlowCommentFilter | null | undefined;
  or?: ReadonlyArray<AdminDashboardFlowCommentFilter> | null | undefined;
};
export type CommentToManyReviewerDashboardFlowCommentFilter = {
  every?: ReviewerDashboardFlowCommentFilter | null | undefined;
  none?: ReviewerDashboardFlowCommentFilter | null | undefined;
  some?: ReviewerDashboardFlowCommentFilter | null | undefined;
};
export type ReviewerDashboardFlowCommentFilter = {
  and?: ReadonlyArray<ReviewerDashboardFlowCommentFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  comment?: CommentFilter | null | undefined;
  commentId?: UUIDFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  not?: ReviewerDashboardFlowCommentFilter | null | undefined;
  or?: ReadonlyArray<ReviewerDashboardFlowCommentFilter> | null | undefined;
};
export type CommentToManyCommentViewedFilter = {
  every?: CommentViewedFilter | null | undefined;
  none?: CommentViewedFilter | null | undefined;
  some?: CommentViewedFilter | null | undefined;
};
export type CommentViewedFilter = {
  and?: ReadonlyArray<CommentViewedFilter> | null | undefined;
  comment?: CommentFilter | null | undefined;
  commentId?: UUIDFilter | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  not?: CommentViewedFilter | null | undefined;
  or?: ReadonlyArray<CommentViewedFilter> | null | undefined;
};
export type GwtUserToManyActivityFilter = {
  every?: ActivityFilter | null | undefined;
  none?: ActivityFilter | null | undefined;
  some?: ActivityFilter | null | undefined;
};
export type GwtUserToManyNotificationFilter = {
  every?: NotificationFilter | null | undefined;
  none?: NotificationFilter | null | undefined;
  some?: NotificationFilter | null | undefined;
};
export type NotificationFilter = {
  and?: ReadonlyArray<NotificationFilter> | null | undefined;
  data?: JSONFilter | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  name?: StringFilter | null | undefined;
  not?: NotificationFilter | null | undefined;
  or?: ReadonlyArray<NotificationFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
};
export type JSONFilter = {
  equalTo?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqualTo?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqualTo?: any | null | undefined;
  notEqualTo?: any | null | undefined;
  notIn?: ReadonlyArray<any> | null | undefined;
};
export type GwtUserToManyFlowFilter = {
  every?: FlowFilter | null | undefined;
  none?: FlowFilter | null | undefined;
  some?: FlowFilter | null | undefined;
};
export type GwtUserToManyModuleSubmissionFilter = {
  every?: ModuleSubmissionFilter | null | undefined;
  none?: ModuleSubmissionFilter | null | undefined;
  some?: ModuleSubmissionFilter | null | undefined;
};
export type ModuleSubmissionFilter = {
  acceptedBy?: GwtUserFilter | null | undefined;
  acceptedByExists?: boolean | null | undefined;
  acceptedById?: UUIDFilter | null | undefined;
  and?: ReadonlyArray<ModuleSubmissionFilter> | null | undefined;
  attempt?: IntFilter | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  galleryAssetSubmissionId?: UUIDFilter | null | undefined;
  moduleFlow?: ModuleFilter | null | undefined;
  moduleFlowId?: UUIDFilter | null | undefined;
  not?: ModuleSubmissionFilter | null | undefined;
  or?: ReadonlyArray<ModuleSubmissionFilter> | null | undefined;
  submissionStatus?: SubmissionStatusFilter | null | undefined;
};
export type SubmissionStatusFilter = {
  equalTo?: SubmissionStatus | null | undefined;
  greaterThan?: SubmissionStatus | null | undefined;
  greaterThanOrEqualTo?: SubmissionStatus | null | undefined;
  in?: ReadonlyArray<SubmissionStatus> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: SubmissionStatus | null | undefined;
  lessThanOrEqualTo?: SubmissionStatus | null | undefined;
  notEqualTo?: SubmissionStatus | null | undefined;
  notIn?: ReadonlyArray<SubmissionStatus> | null | undefined;
};
export type ModuleFilter = {
  and?: ReadonlyArray<ModuleFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  attempts?: IntFilter | null | undefined;
  autoStartNextModuleFlow?: ModuleFilter | null | undefined;
  autoStartNextModuleFlowExists?: boolean | null | undefined;
  autoStartNextModuleFlowId?: UUIDFilter | null | undefined;
  currentAttempt?: IntFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  galleryAssetComponentsId?: UUIDFilter | null | undefined;
  galleryAssetDeliverableId?: UUIDFilter | null | undefined;
  galleryCollectionSubmissionsId?: UUIDFilter | null | undefined;
  groupModulePreviousModuleFlow?: ModuleFilter | null | undefined;
  groupModulePreviousModuleFlowExists?: boolean | null | undefined;
  groupModulePreviousModuleFlowId?: UUIDFilter | null | undefined;
  isFinalAttempt?: BooleanFilter | null | undefined;
  moduleGroup?: ModuleGroupFilter | null | undefined;
  moduleGroupExists?: boolean | null | undefined;
  moduleGroupId?: UUIDFilter | null | undefined;
  moduleGroupLinksByModuleFlowId?: ModuleToManyModuleGroupLinkFilter | null | undefined;
  moduleGroupLinksByModuleFlowIdExist?: boolean | null | undefined;
  moduleSubmissionsByModuleFlowId?: ModuleToManyModuleSubmissionFilter | null | undefined;
  moduleSubmissionsByModuleFlowIdExist?: boolean | null | undefined;
  modulesByAutoStartNextModuleFlowId?: ModuleToManyModuleFilter | null | undefined;
  modulesByAutoStartNextModuleFlowIdExist?: boolean | null | undefined;
  modulesByGroupModulePreviousModuleFlowId?: ModuleToManyModuleFilter | null | undefined;
  modulesByGroupModulePreviousModuleFlowIdExist?: boolean | null | undefined;
  not?: ModuleFilter | null | undefined;
  or?: ReadonlyArray<ModuleFilter> | null | undefined;
  programType?: ProgramTypeFilter | null | undefined;
  softwareType?: SoftwareTypeFilter | null | undefined;
  submissionLock?: BooleanFilter | null | undefined;
  tasksByModuleFlowId?: ModuleToManyTaskFilter | null | undefined;
  tasksByModuleFlowIdExist?: boolean | null | undefined;
  templateFlow?: TemplateFilter | null | undefined;
  templateFlowExists?: boolean | null | undefined;
  templateFlowId?: UUIDFilter | null | undefined;
  versionNumber?: BigFloatFilter | null | undefined;
};
export type SoftwareTypeFilter = {
  equalTo?: SoftwareType | null | undefined;
  greaterThan?: SoftwareType | null | undefined;
  greaterThanOrEqualTo?: SoftwareType | null | undefined;
  in?: ReadonlyArray<SoftwareType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: SoftwareType | null | undefined;
  lessThanOrEqualTo?: SoftwareType | null | undefined;
  notEqualTo?: SoftwareType | null | undefined;
  notIn?: ReadonlyArray<SoftwareType> | null | undefined;
};
export type ProgramTypeFilter = {
  equalTo?: ProgramType | null | undefined;
  greaterThan?: ProgramType | null | undefined;
  greaterThanOrEqualTo?: ProgramType | null | undefined;
  in?: ReadonlyArray<ProgramType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: ProgramType | null | undefined;
  lessThanOrEqualTo?: ProgramType | null | undefined;
  notEqualTo?: ProgramType | null | undefined;
  notIn?: ReadonlyArray<ProgramType> | null | undefined;
};
export type BigFloatFilter = {
  equalTo?: BigFloat | null | undefined;
  greaterThan?: BigFloat | null | undefined;
  greaterThanOrEqualTo?: BigFloat | null | undefined;
  in?: ReadonlyArray<BigFloat> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: BigFloat | null | undefined;
  lessThanOrEqualTo?: BigFloat | null | undefined;
  notEqualTo?: BigFloat | null | undefined;
  notIn?: ReadonlyArray<BigFloat> | null | undefined;
};
export type ModuleToManyModuleFilter = {
  every?: ModuleFilter | null | undefined;
  none?: ModuleFilter | null | undefined;
  some?: ModuleFilter | null | undefined;
};
export type ModuleToManyTaskFilter = {
  every?: TaskFilter | null | undefined;
  none?: TaskFilter | null | undefined;
  some?: TaskFilter | null | undefined;
};
export type TaskFilter = {
  and?: ReadonlyArray<TaskFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  complete?: BooleanFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  moduleFlow?: ModuleFilter | null | undefined;
  moduleFlowExists?: boolean | null | undefined;
  moduleFlowId?: UUIDFilter | null | undefined;
  not?: TaskFilter | null | undefined;
  or?: ReadonlyArray<TaskFilter> | null | undefined;
  priority?: IntFilter | null | undefined;
  templateFlow?: TemplateFilter | null | undefined;
  templateFlowExists?: boolean | null | undefined;
  templateFlowId?: UUIDFilter | null | undefined;
};
export type TemplateFilter = {
  and?: ReadonlyArray<TemplateFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  modulesByTemplateFlowId?: TemplateToManyModuleFilter | null | undefined;
  modulesByTemplateFlowIdExist?: boolean | null | undefined;
  not?: TemplateFilter | null | undefined;
  or?: ReadonlyArray<TemplateFilter> | null | undefined;
  tasksByTemplateFlowId?: TemplateToManyTaskFilter | null | undefined;
  tasksByTemplateFlowIdExist?: boolean | null | undefined;
};
export type TemplateToManyModuleFilter = {
  every?: ModuleFilter | null | undefined;
  none?: ModuleFilter | null | undefined;
  some?: ModuleFilter | null | undefined;
};
export type TemplateToManyTaskFilter = {
  every?: TaskFilter | null | undefined;
  none?: TaskFilter | null | undefined;
  some?: TaskFilter | null | undefined;
};
export type ModuleToManyModuleSubmissionFilter = {
  every?: ModuleSubmissionFilter | null | undefined;
  none?: ModuleSubmissionFilter | null | undefined;
  some?: ModuleSubmissionFilter | null | undefined;
};
export type ModuleToManyModuleGroupLinkFilter = {
  every?: ModuleGroupLinkFilter | null | undefined;
  none?: ModuleGroupLinkFilter | null | undefined;
  some?: ModuleGroupLinkFilter | null | undefined;
};
export type ModuleGroupLinkFilter = {
  and?: ReadonlyArray<ModuleGroupLinkFilter> | null | undefined;
  groupIndex?: IntFilter | null | undefined;
  moduleFlow?: ModuleFilter | null | undefined;
  moduleFlowId?: UUIDFilter | null | undefined;
  moduleGroupFlow?: ModuleGroupFilter | null | undefined;
  moduleGroupFlowId?: UUIDFilter | null | undefined;
  not?: ModuleGroupLinkFilter | null | undefined;
  or?: ReadonlyArray<ModuleGroupLinkFilter> | null | undefined;
};
export type ModuleGroupFilter = {
  and?: ReadonlyArray<ModuleGroupFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  moduleGroupLinksByModuleGroupFlowId?: ModuleGroupToManyModuleGroupLinkFilter | null | undefined;
  moduleGroupLinksByModuleGroupFlowIdExist?: boolean | null | undefined;
  modules?: ModuleGroupToManyModuleFilter | null | undefined;
  modulesExist?: boolean | null | undefined;
  not?: ModuleGroupFilter | null | undefined;
  or?: ReadonlyArray<ModuleGroupFilter> | null | undefined;
  programTypes?: ProgramTypeListFilter | null | undefined;
  shuffle?: BooleanFilter | null | undefined;
  softwareTypes?: SoftwareTypeListFilter | null | undefined;
  versionNumber?: BigFloatFilter | null | undefined;
};
export type SoftwareTypeListFilter = {
  equalTo?: ReadonlyArray<SoftwareType | null | undefined> | null | undefined;
  greaterThan?: ReadonlyArray<SoftwareType | null | undefined> | null | undefined;
  greaterThanOrEqualTo?: ReadonlyArray<SoftwareType | null | undefined> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: ReadonlyArray<SoftwareType | null | undefined> | null | undefined;
  lessThanOrEqualTo?: ReadonlyArray<SoftwareType | null | undefined> | null | undefined;
  notEqualTo?: ReadonlyArray<SoftwareType | null | undefined> | null | undefined;
};
export type ModuleGroupToManyModuleFilter = {
  every?: ModuleFilter | null | undefined;
  none?: ModuleFilter | null | undefined;
  some?: ModuleFilter | null | undefined;
};
export type ModuleGroupToManyModuleGroupLinkFilter = {
  every?: ModuleGroupLinkFilter | null | undefined;
  none?: ModuleGroupLinkFilter | null | undefined;
  some?: ModuleGroupLinkFilter | null | undefined;
};
export type GwtUserToManyFlowReviewerFilter = {
  every?: FlowReviewerFilter | null | undefined;
  none?: FlowReviewerFilter | null | undefined;
  some?: FlowReviewerFilter | null | undefined;
};
export type FlowReviewerFilter = {
  and?: ReadonlyArray<FlowReviewerFilter> | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  not?: FlowReviewerFilter | null | undefined;
  or?: ReadonlyArray<FlowReviewerFilter> | null | undefined;
  reviewer?: GwtUserFilter | null | undefined;
  reviewerId?: UUIDFilter | null | undefined;
};
export type GwtUserToManyFlowFavoriteFilter = {
  every?: FlowFavoriteFilter | null | undefined;
  none?: FlowFavoriteFilter | null | undefined;
  some?: FlowFavoriteFilter | null | undefined;
};
export type FlowFavoriteFilter = {
  and?: ReadonlyArray<FlowFavoriteFilter> | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  not?: FlowFavoriteFilter | null | undefined;
  or?: ReadonlyArray<FlowFavoriteFilter> | null | undefined;
};
export type GwtUserToManyCommentViewedFilter = {
  every?: CommentViewedFilter | null | undefined;
  none?: CommentViewedFilter | null | undefined;
  some?: CommentViewedFilter | null | undefined;
};
export type GwtUserToManyCompanyFilter = {
  every?: CompanyFilter | null | undefined;
  none?: CompanyFilter | null | undefined;
  some?: CompanyFilter | null | undefined;
};
export type CompanyFilter = {
  and?: ReadonlyArray<CompanyFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  description?: StringFilter | null | undefined;
  gwtUsers?: CompanyToManyGwtUserFilter | null | undefined;
  gwtUsersExist?: boolean | null | undefined;
  name?: StringFilter | null | undefined;
  not?: CompanyFilter | null | undefined;
  numberOfCertifications?: IntFilter | null | undefined;
  numberOfUsers?: IntFilter | null | undefined;
  or?: ReadonlyArray<CompanyFilter> | null | undefined;
  owner?: GwtUserFilter | null | undefined;
  ownerId?: UUIDFilter | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  updatedAt?: DatetimeFilter | null | undefined;
};
export type CompanyToManyGwtUserFilter = {
  every?: GwtUserFilter | null | undefined;
  none?: GwtUserFilter | null | undefined;
  some?: GwtUserFilter | null | undefined;
};
export type GwtUserToManyPolFileUploadFilter = {
  every?: PolFileUploadFilter | null | undefined;
  none?: PolFileUploadFilter | null | undefined;
  some?: PolFileUploadFilter | null | undefined;
};
export type PolFileUploadFilter = {
  and?: ReadonlyArray<PolFileUploadFilter> | null | undefined;
  fileName?: StringFilter | null | undefined;
  fileSize?: BigIntFilter | null | undefined;
  galleryAssetId?: UUIDFilter | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  not?: PolFileUploadFilter | null | undefined;
  or?: ReadonlyArray<PolFileUploadFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  tossKey?: StringFilter | null | undefined;
  tossUrl?: StringFilter | null | undefined;
  uploadError?: StringFilter | null | undefined;
  uploadStatus?: PolFileUploadStatusFilter | null | undefined;
};
export type BigIntFilter = {
  equalTo?: BigInt | null | undefined;
  greaterThan?: BigInt | null | undefined;
  greaterThanOrEqualTo?: BigInt | null | undefined;
  in?: ReadonlyArray<BigInt> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: BigInt | null | undefined;
  lessThanOrEqualTo?: BigInt | null | undefined;
  notEqualTo?: BigInt | null | undefined;
  notIn?: ReadonlyArray<BigInt> | null | undefined;
};
export type PolFileUploadStatusFilter = {
  equalTo?: PolFileUploadStatus | null | undefined;
  greaterThan?: PolFileUploadStatus | null | undefined;
  greaterThanOrEqualTo?: PolFileUploadStatus | null | undefined;
  in?: ReadonlyArray<PolFileUploadStatus> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: PolFileUploadStatus | null | undefined;
  lessThanOrEqualTo?: PolFileUploadStatus | null | undefined;
  notEqualTo?: PolFileUploadStatus | null | undefined;
  notIn?: ReadonlyArray<PolFileUploadStatus> | null | undefined;
};
export type GwtUserToManyFeedbackFilter = {
  every?: FeedbackFilter | null | undefined;
  none?: FeedbackFilter | null | undefined;
  some?: FeedbackFilter | null | undefined;
};
export type FeedbackFilter = {
  and?: ReadonlyArray<FeedbackFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  claimedBy?: GwtUserFilter | null | undefined;
  claimedByExists?: boolean | null | undefined;
  claimedById?: UUIDFilter | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  feedback?: StringFilter | null | undefined;
  feedbackLevel?: FeedbackLevelFilter | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  not?: FeedbackFilter | null | undefined;
  or?: ReadonlyArray<FeedbackFilter> | null | undefined;
  resolved?: BooleanFilter | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  updatedAt?: DatetimeFilter | null | undefined;
};
export type FeedbackLevelFilter = {
  equalTo?: FeedbackLevel | null | undefined;
  greaterThan?: FeedbackLevel | null | undefined;
  greaterThanOrEqualTo?: FeedbackLevel | null | undefined;
  in?: ReadonlyArray<FeedbackLevel> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: FeedbackLevel | null | undefined;
  lessThanOrEqualTo?: FeedbackLevel | null | undefined;
  notEqualTo?: FeedbackLevel | null | undefined;
  notIn?: ReadonlyArray<FeedbackLevel> | null | undefined;
};
export type FlowToManyFlowReviewerFilter = {
  every?: FlowReviewerFilter | null | undefined;
  none?: FlowReviewerFilter | null | undefined;
  some?: FlowReviewerFilter | null | undefined;
};
export type FlowToManyFlowCommentFilter = {
  every?: FlowCommentFilter | null | undefined;
  none?: FlowCommentFilter | null | undefined;
  some?: FlowCommentFilter | null | undefined;
};
export type FlowToManyAdminDashboardFlowCommentFilter = {
  every?: AdminDashboardFlowCommentFilter | null | undefined;
  none?: AdminDashboardFlowCommentFilter | null | undefined;
  some?: AdminDashboardFlowCommentFilter | null | undefined;
};
export type FlowToManyReviewerDashboardFlowCommentFilter = {
  every?: ReviewerDashboardFlowCommentFilter | null | undefined;
  none?: ReviewerDashboardFlowCommentFilter | null | undefined;
  some?: ReviewerDashboardFlowCommentFilter | null | undefined;
};
export type FlowToManyFlowFavoriteFilter = {
  every?: FlowFavoriteFilter | null | undefined;
  none?: FlowFavoriteFilter | null | undefined;
  some?: FlowFavoriteFilter | null | undefined;
};
export type ReviewerStatusCardPaginationQuery$variables = {
  count: number;
  flowFilter?: FlowFilter | null | undefined;
  flowsOrderBy?: ReadonlyArray<FlowsOrderBy> | null | undefined;
};
export type ReviewerStatusCardPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ReviewerStatusCardPaginationFragment_flows">;
};
export type ReviewerStatusCardPaginationQuery = {
  response: ReviewerStatusCardPaginationQuery$data;
  variables: ReviewerStatusCardPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "flowFilter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "flowsOrderBy"
},
v3 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "flowFilter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "flowsOrderBy"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lanId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReviewerStatusCardPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "flowFilter",
            "variableName": "flowFilter"
          },
          {
            "kind": "Variable",
            "name": "flowsOrderBy",
            "variableName": "flowsOrderBy"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ReviewerStatusCardPaginationFragment_flows"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReviewerStatusCardPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "FlowsConnection",
        "kind": "LinkedField",
        "name": "flows",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FlowsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Flow",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkedType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GwtUser",
                    "kind": "LinkedField",
                    "name": "assignedTo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userPriority",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlowReviewersConnection",
                    "kind": "LinkedField",
                    "name": "flowReviewers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowReviewer",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GwtUser",
                            "kind": "LinkedField",
                            "name": "reviewer",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Company",
                                "kind": "LinkedField",
                                "name": "company",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dueAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignmentStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignmentDueAtStatus",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "filters": [
          "filter",
          "orderBy"
        ],
        "handle": "connection",
        "key": "ReviewerStatusCard_flows",
        "kind": "LinkedHandle",
        "name": "flows"
      }
    ]
  },
  "params": {
    "cacheID": "615a776c996742dc4994f079da6f7390",
    "id": null,
    "metadata": {},
    "name": "ReviewerStatusCardPaginationQuery",
    "operationKind": "query",
    "text": "query ReviewerStatusCardPaginationQuery(\n  $flowFilter: FlowFilter\n  $flowsOrderBy: [FlowsOrderBy!]\n  $count: Int!\n) {\n  ...ReviewerStatusCardPaginationFragment_flows_2m6jvQ\n}\n\nfragment FlowLink_flow on Flow {\n  rowId\n  linkedType\n}\n\nfragment ReassignReviewerPopupFragment_AssignToAvatar on GwtUser {\n  firstName\n  lastName\n  rowId\n}\n\nfragment ReassignReviewerPopupFragment_ReviewerAvatar on GwtUser {\n  firstName\n  lastName\n  rowId\n  company {\n    name\n    id\n  }\n}\n\nfragment ReviewerStatusCardPaginationFragment_flows_2m6jvQ on Query {\n  flows(filter: $flowFilter, orderBy: $flowsOrderBy, first: $count) {\n    edges {\n      node {\n        name\n        rowId\n        ...FlowLink_flow\n        assignedTo {\n          ...UserPriority_gwtUser\n          ...UserAvatar_gwtUser\n          ...ReassignReviewerPopupFragment_AssignToAvatar\n          id\n        }\n        flowReviewers {\n          nodes {\n            reviewer {\n              ...UserAvatar_gwtUser\n              ...ReassignReviewerPopupFragment_ReviewerAvatar\n              id\n            }\n            id\n          }\n        }\n        ...StatusChip_flow\n        dueAt\n        assignmentStatus\n        assignmentDueAtStatus\n        id\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment StatusChip_flow on Flow {\n  dueAt\n  assignmentStatus\n  assignmentDueAtStatus\n}\n\nfragment UserAvatar_gwtUser on GwtUser {\n  id\n  firstName\n  lastName\n  lanId\n}\n\nfragment UserPriority_gwtUser on GwtUser {\n  userPriority\n}\n"
  }
};
})();

(node as any).hash = "393219a915266f41eb91fd9a923ee5b1";

export default node;
